import React from 'react'
import styled from 'styled-components'

const Footer = (props) => {

  const FooterColor = styled.footer`
    color: ${props.themeStyles.fontColorLight}
  `

  const theDate = new Date()
  const Year = theDate.getFullYear()

  return (
    <FooterColor>
      <span className="copyright">
        Copyright &copy; 1989-{Year} Driver's Alert. All rights reserved.
        <a target="_blank" style={{color: props.themeStyles.fontColorLight, textDecoration: 'underline', paddingLeft: '1em'}} href="https://www.driversalert.com/contact-drivers-alert">Contact Driver's Alert</a></span>
    </FooterColor>
  )

}

export default Footer
